/**
 * Routing-Heuristiken für RedirectFromRoot.
 *
 * Eingeführt in Slice-4 (2026-05-09) für die `/`→`/dashboard`-Migration.
 * Wenn ein User auf `/` mit Library-Filter-Params landet (alte Bookmarks),
 * werden NUR die erkannten LIBRARY_FILTER_PARAMS an `/library?...`
 * weitergegeben — unbekannte Params (utm_source, ref, fbclid etc.)
 * werden discarded.
 *
 * Liste muss synchron mit `LibraryPage.tsx` URL-Reads bleiben:
 * `type`, `q`, `sort`, `dir`, `view`, `status` werden via useSearchParams
 * gelesen. `density` ist localStorage-only und gehört NICHT in die Liste.
 *
 * Separates Modul, weil Routing-Regeln und Pub-Sub-Constants orthogonale
 * Concerns sind.
 */
export const LIBRARY_FILTER_PARAMS = [
  'type',
  'q',
  'sort',
  'dir',
  'view',
  'status',
] as const;

export type LibraryFilterParam = (typeof LIBRARY_FILTER_PARAMS)[number];
